$(document).ready(function () {
    $('[data-submit-on-change]').each(function () {
        var form = $(this);
        form.find('input, select').on('change', () => {
            form.submit();
        });
    });
});
